<div>
    <app-tree-node 
      *ngFor="let node of nodes" 
      [node]="node"
      [activeNodeId]="activeNodeId"
      (nodeClicked)="handleNodeClick($event)">
    </app-tree-node>
  </div>